"use client";

import { useRef } from "react";
import { usePathname } from "next/navigation";
import { isExamInfoPage } from "@/lib/route-layout";
import { useEffectivePass } from "@/hooks/useEffectivePass";
import { ADSENSE_CLIENT, ADSENSE_SLOTS } from "@/lib/adsense";
import { useAdSensePush } from "@/hooks/useAdSensePush";

interface AdSenseInlineProblemProps {
  adSlot?: string;
}

export default function AdSenseInlineProblem({ adSlot }: AdSenseInlineProblemProps) {
  const { isAdFree, isLoaded } = useEffectivePass();
  const pathname = usePathname();
  const showAds = isLoaded && !isAdFree && !isExamInfoPage(pathname);
  const slot = adSlot ?? ADSENSE_SLOTS.inlineProblem;
  const insRef = useRef<HTMLModElement>(null);

  // dev/목업 모드에서도 동일하게 push한다(mock SDK가 채움). 동작 일치로 버그 재현.
  useAdSensePush(insRef, showAds && !!slot);

  if (!showAds || !slot) {
    return null;
  }

  return (
    <div className="my-4" data-llm-copy-skip="true">
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
